module.exports = __webpack_public_path__ + "assets/img/m33.287270e8.png";